export enum FeedSource {
  MANUAL = 'manual',
  BEST_MIX = 'bestMix',
}
